export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12133.ac7e6e87.jpg";